"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultLayout = void 0;
var _appLoaders = require("@ori-appshell/app-loaders");
var _auth = require("@ori/auth");
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _featureToggles = require("@ori/feature-toggles");
var _geolocationPopup = require("@ori/geolocation-popup");
var _i18n = require("@ori/i18n");
var _languageSwitcher = require("@ori/language-switcher");
var _skipTo = require("@ori/skip-to");
var _termsAndConditions = require("@ori/terms-and-conditions");
var _ChatsLoader = require("../../../components/ChatsLoader");
var _Footer = require("../../../components/Footer");
var _LanguageSwitcher = require("../../../components/LanguageSwitcher");
var _PageBackgroundColor = require("../../../components/PageBackgroundColor");
var _TopArea = require("../../../components/TopArea");
var _DefaultLayoutFeature = require("../DefaultLayoutFeature");
var _jsxRuntime = require("react/jsx-runtime");
const DefaultLayout = ({
  children,
  languages,
  pageBackgroundColorVariant,
  componentsProps
}) => {
  const {
    appLoaders
  } = (0, _appLoaders.useAppLoaders)();
  const {
    isFeatureEnabled
  } = (0, _featureToggles.useFeatureToggles)();
  const {
    customerId,
    token
  } = (0, _auth.useToken)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    translationsWithNamespaces
  } = (0, _i18n.useTranslationsWithNamespaces)();
  const {
    staticApiUrl
  } = (0, _configurationManager.useServiceUrls)(['staticApi']);
  const {
    environment,
    tenant
  } = (0, _environment.useEnvironment)();
  const disableLanguageSwitcherPopUp = isFeatureEnabled(_LanguageSwitcher.LanguageSwitcherFeature.DisableLanguageSwitcherPopUp);
  const useInternationalShareAndEarn = isFeatureEnabled(_DefaultLayoutFeature.DefaultLayoutFeature.InternationalShareAndEarn);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_PageBackgroundColor.PageBackgroundColor, {
      variant: pageBackgroundColorVariant
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_skipTo.SkipTo, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TopArea.TopArea, {
      showSearchOnScroll: componentsProps?.topArea?.showTopAreaSearchOnScroll
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("main", {
      id: "main-content",
      children: children
    }), !disableLanguageSwitcherPopUp && /*#__PURE__*/(0, _jsxRuntime.jsx)(_languageSwitcher.LanguageSwitcherPopup, {
      currentLanguage: language,
      staticApiUrl: staticApiUrl,
      tenant: tenant,
      translations: translationsWithNamespaces?.[_languageSwitcher.translationsNamespace],
      prefetchedLanguages: languages
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Footer.FooterLazyLoader, {
      showFooterAboutSection: componentsProps?.footer?.showFooterAboutSection
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_termsAndConditions.TermsAndConditions, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatsLoader.ChatsLoader, {
      ...componentsProps?.chats
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_geolocationPopup.Geolocation, {
      enabled: useInternationalShareAndEarn
    }), appLoaders ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_appLoaders.AppLoaders, {
      customerId: customerId,
      environment: environment,
      libs: appLoaders.libs,
      spas: appLoaders.spas,
      token: token
    }) : null]
  });
};
exports.DefaultLayout = DefaultLayout;
